import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AppStore, StorageService } from '@kanek/shared-data-access';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: ` <router-outlet /> `,
})
export class AppComponent implements OnInit {
  appStore = inject(AppStore);
  router = inject(Router);
  private storageService = inject(StorageService);

  async ngOnInit() {
    // Initialize storage for dashboard persistence
    await this.storageService.init();
  }
}
